import React from 'react';
import { useTranslation } from 'react-i18next';

import { TextInputPlaceholder } from './styled';

const TextInputEditor = () => {
  const { t } = useTranslation('common');

  return (
    <TextInputPlaceholder>
      {t('assistant.scriptDialog.textInputPlaceholder')}
    </TextInputPlaceholder>
  );
};

export default TextInputEditor;
